import { Input } from "antd";
import styled, { css } from "styled-components";

export type InputStatus = "less" | "more" | "neutral";

export const StyledTaskFacings = styled.div<{ $isActive: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    background: ${({ theme, $isActive }) =>
        $isActive ? theme.tabsAPBackground : "transparent"};
`;

export const StyledCommentIndicator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
`;

export const StyledFacingsInput = styled(Input)<{ $status: InputStatus }>`
    width: 80px;
    text-align: center;

    ${({ $status, theme }) => {
        switch ($status) {
            case "less":
                return css`
                    border-color: ${theme.dangerTypographyColor};
                `;
            case "more":
                return css`
                    border-color: ${theme.successTypographyColor}90;
                `;
            default:
                return;
        }
    }}
`;
